import type { HTMLAttributes } from 'react';
import type { SafeAny } from '@trg/utils';
import { ApiContextProvider } from '@trg/api';
import { Footer } from '../../footer';
import {
  createReactApp,
  createTailwindLink,
  registerCustomElement,
} from '../utils';

const CUSTOM_FOOTER_TAG_NAME = 'custom-footer';

class CustomFooter extends HTMLElement {
  constructor() {
    super();

    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    if (!this.shadowRoot) return;

    const tailwindLink = createTailwindLink({
      environment: process.env['NODE_ENV'] as SafeAny,
    });
    this.shadowRoot.appendChild(tailwindLink);

    createReactApp(
      this.shadowRoot,
      <ApiContextProvider value={{ host: process.env['TLW_API_HOST'] }}>
        <Footer />
      </ApiContextProvider>
    );
  }
}

export type NewFooterProps = Omit<HTMLAttributes<HTMLElement>, 'children'>;

export function NewFooter({ style, ...props }: NewFooterProps) {
  registerCustomElement(CUSTOM_FOOTER_TAG_NAME, CustomFooter);

  return (
    <custom-footer
      style={{ position: 'static', ...style }}
      {...props}
      part="NoFooter"
    />
  );
}
